import { BaseFieldClass } from './baseField.class'

import { IBoolField } from '@/types/serverField.type'

export class BoolFieldClass extends BaseFieldClass {
  declare fieldValue: boolean
  declare initialValue: boolean

  constructor (field: IBoolField) {
    super(field)
    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as boolean | null)
    this.fieldValue = this.prepareValue(value as boolean | null)
  }

  prepareValue (value: boolean | null): boolean {
    return Boolean(value)
  }

  getValue (): Record<string, boolean> {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (formData: FormData): void {
    formData.append(this.name, String(this.fieldValue))
  }

  setFilterValue (value: unknown): void {
    this.fieldValue = String(value) === 'true'
  }

  getFilterValue (): boolean {
    const raw = (Array.isArray(this.value) && this.value.length) ? this.value[0] : this.value
    return String(raw) === 'true'
  }

  getValueAsText (): string {
    const raw = (Array.isArray(this.value) && this.value.length) ? this.value[0] : this.value
    return String(raw) === 'true' ? 'Да' : 'Нет'
  }
}
